
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Sedantaxihireinpune() {



    const cardData =
    {
        keyword: 'Sedan Taxi Hire in Pune',
        heading: 'Platinum24 Cabs: Sedan Taxi Hire in Pune',
        headingDescription: ' Platinum24 Cabs provides comfortable Sedan Taxi Hire in Pune, perfect for business travel, airport transfers, city rides, and outstation trips. Our fleet of premium sedans like Swift Dzire, Honda Amaze, and similar models ensures smooth rides with spacious seating, air-conditioned comfort, and excellent mileage. With professional chauffeurs, timely pickups, and transparent pricing, we deliver reliable sedan cab services for both individuals and families. Whether it’s a corporate commute, a weekend getaway, or a long-distance journey, Platinum24 Cabs guarantees affordable, safe, and hassle-free sedan taxi rentals in Pune.',

        top: 'Top Places to Visit in Pune with Platinum24 Cabs',

"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s most iconic fort palace. Once the seat of the Maratha Empire, its majestic gates, fountains, and sprawling gardens narrate stories of valor and legacy. Though partially destroyed by fire in 1828, its ruins still captivate tourists. The evening light-and-sound show brings alive Bajirao and Mastani’s era. A must-visit for history lovers, it is Pune’s proud heritage landmark."
  },
  {
    "title": "Aga Khan Palace",
    "description": "The Aga Khan Palace, constructed in 1892, is a historic monument tied to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now houses a museum showcasing Gandhi’s personal belongings and rare photographs. Its Italian arches, sprawling lawns, and tranquil vibe make it a top tourist attraction. It is Pune’s historic gem of inspiration and peace."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Sinhagad Fort, 25 km from Pune, is famous for the 1670 battle fought by Tanaji Malusare for Chhatrapati Shivaji Maharaj. Perched on a hill, it offers trekking trails and panoramic Sahyadri views. Visitors explore bastions, memorials, and temples that echo Maratha bravery. Monsoon enhances its beauty with misty clouds and waterfalls. Locals serve rustic pithla-bhakri at the fort. Sinhagad is Pune’s perfect mix of adventure, history, and nature."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The grand idol is adorned with gold and jewels, attracting thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of festivities. It is also known for charitable and cultural activities. The spiritual energy here is unmatched. Dagdusheth Temple is Pune’s divine cultural and spiritual heart."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple, carved in the 8th century, is dedicated to Lord Shiva. Its rock-cut sanctum, stone pillars, and Nandi mandapa reflect ancient Indian craftsmanship. Despite being in the heart of the city, it offers peace and a spiritual retreat. Evening aartis create a mystical aura. History lovers admire its timeless carvings. Pataleshwar is Pune’s hidden gem of spirituality and heritage."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "The Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar. Exhibits include ornaments, musical instruments, sculptures, and antiques from daily life. Its highlight is the recreated Mastani Mahal. Students and history lovers find it highly educational and engaging. The museum preserves traditions from across India’s regions. It is Pune’s cultural treasure chest of art and heritage."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic views of the city. The Parvati Temple atop the hill is dedicated to Lord Shiva and Goddess Parvati, built during the Peshwa era. Visitors climb 103 steps to reach the temple, blending devotion with adventure. The site also houses a small museum and shrines. Sunsets and sunrises from here are breathtaking. Parvati Hill is Pune’s sacred and scenic retreat."
  },
  {
    "title": "Osho Ashram",
    "description": "The Osho International Meditation Resort in Koregaon Park is Pune’s global hub of wellness and spirituality. Spread across lush gardens, it offers meditation, yoga, and self-discovery programs. Japanese Zen gardens, swimming pools, and meditation halls enhance the experience. It attracts seekers from across the world. Visitors leave with peace and rejuvenation. Osho Ashram is Pune’s international center of mindfulness."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, modeled after Japan’s Korakuen Garden, is Pune’s largest landscaped park. It features flowing streams, stone bridges, and beautifully manicured lawns. Families enjoy walks, photography, and picnics here. Seasonal flowers and greenery make it picturesque year-round. It symbolizes Indo-Japanese friendship. Pu La Deshpande Garden is Pune’s green paradise of peace and beauty."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam on the Mutha River is a popular weekend retreat near Pune. It supplies water to the city while offering scenic landscapes of hills and waters. In monsoon, the dam overflows spectacularly, drawing crowds. Vendors serve hot corn and tea, adding to the charm. It also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s refreshing natural escape."
  }
],



    "services": [
    {
      "name": "Sedan Taxi Service Pune",
      "description": "Experience comfortable and stylish travel with our Sedan Taxi Service in Pune. Ideal for business trips, airport transfers, and city travel, our sedan taxis provide a perfect blend of luxury and affordability. With well-maintained cars and professional drivers, we ensure a smooth, safe, and punctual journey every time. Whether it's a short city ride or a long-distance trip, our sedan taxis offer spacious interiors, air conditioning, and a premium experience tailored to your needs."
    },
    {
      "name": "Pune Sedan Cab Booking",
      "description": "Book your Pune Sedan Cab with ease through our user-friendly online platform or via phone. Our streamlined booking process guarantees quick confirmation and transparent pricing. Enjoy hassle-free travel with reliable pickups and drop-offs, supported by our fleet of modern sedans driven by courteous and experienced drivers. Whether for business or leisure, our booking service adapts to your schedule and preferences."
    },
    {
      "name": "Affordable Sedan Taxi Pune",
      "description": "Get the best value for your money with our Affordable Sedan Taxi service in Pune. We combine cost-effectiveness with comfort and reliability to deliver an unbeatable taxi experience. Our transparent pricing policies and no-hidden-fee commitment make us the preferred choice for budget-conscious travelers seeking quality service without compromise."
    },
    {
      "name": "Sedan Car Hire Pune",
      "description": "Rent a sedan car in Pune for daily commutes, airport transfers, or special occasions. Our sedan car hire service offers flexible rental packages including hourly, daily, and long-term options. Choose from a variety of well-maintained sedans equipped with modern features and enjoy the convenience of a personal driver or self-drive options tailored to your preferences."
    },
    {
      "name": "Pune Sedan Taxi with Driver",
      "description": "Travel effortlessly with our Pune Sedan Taxi service with a professional driver. Our chauffeurs are well-trained, courteous, and knowledgeable about Pune’s roads and traffic, ensuring you reach your destination safely and on time. Enjoy a stress-free journey with door-to-door service, local guidance, and assistance with luggage."
    },
    {
      "name": "Sedan Cab Rental Pune",
      "description": "Our Sedan Cab Rental service in Pune offers premium vehicles on rent for hourly, daily, or multi-day trips. Whether you require a taxi for a corporate event, family outing, or sightseeing tour, our rental packages are designed for flexibility and convenience. Benefit from competitive rates, insured vehicles, and dedicated customer support."
    },
    {
      "name": "Pune Sedan Taxi Packages",
      "description": "Choose from a variety of Sedan Taxi Packages in Pune that suit your travel needs. Our packages include city tours, airport transfers, corporate travel, and outstation trips with fixed rates and inclusive services. Customize your travel plan with options for waiting time, multiple stops, and driver allowances to get the best deal for your journey."
    },
    {
      "name": "Pune Sedan Airport Taxi",
      "description": "Make your airport transfers seamless with our Pune Sedan Airport Taxi service. We monitor flight schedules to provide timely pickups and drop-offs, ensuring you never miss a flight or face delays. Our sedans offer ample space for luggage, comfortable seating, and professional drivers to guarantee a smooth start or end to your journey."
    },
    {
      "name": "Pune Sedan Outstation Taxi",
      "description": "Explore destinations outside Pune with our Sedan Outstation Taxi service. Perfect for weekend trips, business travels, and pilgrimages, our sedans combine comfort, safety, and efficiency for long-distance rides. Enjoy well-maintained vehicles, experienced drivers, and personalized itineraries for a memorable journey beyond the city limits."
    },
    {
      "name": "Sedan Taxi Deals Pune",
      "description": "Take advantage of exclusive Sedan Taxi Deals in Pune, offering discounts and special offers for frequent travelers, corporate clients, and early bookings. Our deals ensure affordable luxury and premium service without stretching your budget. Keep an eye on our seasonal promotions and loyalty programs to maximize your savings."
    },
    {
      "name": "Pune Sedan Taxi Rates",
      "description": "Our Pune Sedan Taxi Rates are competitive and transparent, designed to provide value for money without hidden costs. Rates vary based on distance, duration, and package type, with options for one-way trips, round trips, and hourly rentals. Contact us for customized quotes tailored to your specific travel requirements."
    },
    {
      "name": "Sedan Taxi for Corporate Pune",
      "description": "Elevate your business travel with our Sedan Taxi service for corporate clients in Pune. We offer reliable, punctual, and discreet transportation solutions suited for meetings, conferences, and employee commutes. Benefit from tailored billing, priority bookings, and dedicated account management to ensure a seamless corporate travel experience."
    },
    {
      "name": "Sedan Taxi Service Near Me Pune",
      "description": "Looking for a reliable sedan taxi service near you in Pune? Our extensive network ensures prompt availability and quick dispatch of sedan cabs in your vicinity. Whether you need a ride for urgent travel or pre-booked service, find trusted and verified taxis close to your location for hassle-free transportation."
    },
    {
      "name": "Sedan Taxi Booking Online Pune",
      "description": "Conveniently book your sedan taxi online in Pune through our secure and user-friendly platform. With real-time vehicle tracking, instant booking confirmation, and multiple payment options, our online booking system makes your travel planning effortless. Manage your trips, cancellations, and special requests all in one place."
    },
    {
      "name": "Pune Sedan Cab Service 24x7",
      "description": "Our Pune Sedan Cab Service operates 24x7 to provide you with round-the-clock availability. Whether you need an early morning ride, late-night airport transfer, or emergency travel, our fleet of sedans and professional drivers are ready to serve you anytime. Enjoy reliable, safe, and comfortable transportation whenever you need it."
    }
  ],
  "tableData": [
    ["Sedan Taxi Service Pune", "Pune Sedan Cab Booking"],
    ["Affordable Sedan Taxi Pune", "Sedan Car Hire Pune"],
    ["Pune Sedan Taxi with Driver", "Sedan Cab Rental Pune"],
    ["Pune Sedan Taxi Packages", "Pune Sedan Airport Taxi"],
    ["Pune Sedan Outstation Taxi", "Sedan Taxi Deals Pune"],
    ["Pune Sedan Taxi Rates", "Sedan Taxi for Corporate Pune"],
    ["Sedan Taxi Service Near Me Pune", "Sedan Taxi Booking Online Pune"],
    ["Pune Sedan Cab Service 24x7", "—"]
  ],


      "whychoose": [
    {
      "WhyChooseheading": "Reliable Sedan Taxi Hire in Pune",
      "WhyChoosedescription": "Platinum24 Cabs offers comfortable and affordable sedan taxi services across Pune for all your travel needs."
    },
    {
      "WhyChooseheading": "Well-Maintained and Clean Sedans",
      "WhyChoosedescription": "Travel in sanitized, air-conditioned sedans that ensure a smooth and pleasant ride."
    },
    {
      "WhyChooseheading": "Experienced Drivers with Local Knowledge",
      "WhyChoosedescription": "Our professional drivers are familiar with Pune’s roads to provide safe and timely transportation."
    },
    {
      "WhyChooseheading": "Flexible Booking Options for Local and Outstation Trips",
      "WhyChoosedescription": "Choose from hourly rentals, one-way trips, or round trips tailored to your requirements."
    },
    {
      "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
      "WhyChoosedescription": "Enjoy clear and upfront pricing including fuel, tolls, and driver allowances."
    },
    {
      "WhyChooseheading": "Easy Online Booking and 24/7 Customer Support",
      "WhyChoosedescription": "Book your sedan taxi anytime with help from our responsive support team."
    },
    {
      "WhyChooseheading": "Ideal for Business Travel, Airport Transfers, and Personal Use",
      "WhyChoosedescription": "Our sedan taxis cater to corporate clients as well as individual travelers."
    },
    {
      "WhyChooseheading": "Multiple Sedan Models to Choose From",
      "WhyChoosedescription": "Select the sedan that suits your comfort and style preferences from our fleet."
    }
  ]































    }

const faqData = [
    {
        question: 'Does Platinum24 Cabs offer sedan taxi hire services in Pune?',
        answer: 'Yes, Platinum24 Cabs provides reliable and comfortable sedan taxi hire services in Pune for all your travel needs.',
    },
    {
        question: 'How can I book a sedan taxi in Pune with Platinum24 Cabs?',
        answer: 'You can easily book a sedan taxi through our website, mobile app, or by contacting our customer support team.',
    },
    {
        question: 'What types of sedans are available for hire in Pune?',
        answer: 'We offer a variety of sedan models including Toyota Etios, Honda City, Maruti Suzuki Ciaz, and other popular options.',
    },
    {
        question: 'Can I hire a sedan taxi for local Pune travel as well as outstation trips?',
        answer: 'Yes, sedan taxis are available for both local travel within Pune and outstation journeys.',
    },
    {
        question: 'Are the sedan taxi drivers professional and experienced?',
        answer: 'Absolutely. Our drivers are trained, professional, and knowledgeable about Pune and surrounding areas.',
    },
    {
        question: 'Can I book sedan taxis for hourly rentals or full-day usage?',
        answer: 'Yes, we offer flexible hourly and full-day rental packages for sedan taxis in Pune.',
    },
    {
        question: 'Are the sedan taxis sanitized and safe for travel?',
        answer: 'Yes, all our sedans are regularly sanitized, well-maintained, and follow strict safety protocols.',
    },
    {
        question: 'Can I specify pickup and drop locations when hiring a sedan taxi?',
        answer: 'Yes, you can customize your pickup and drop-off points as per your convenience.',
    },
    {
        question: 'What payment methods are accepted for sedan taxi hire?',
        answer: 'We accept cash, credit/debit cards, and various digital payment options for your convenience.',
    },
    {
        question: 'Is 24x7 sedan taxi service available in Pune?',
        answer: 'Yes, our sedan taxi services are available round the clock to cater to your travel needs.',
    },
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Vikram Shah',
        feedback: 'The sedan taxi I hired from Platinum24 Cabs was very comfortable and the driver was punctual and courteous.',
        rating: 5,
    },
    {
        id: 2,
        name: 'Ms. Anjali Kulkarni',
        feedback: 'Great experience with Platinum24 Cabs sedan hire. The booking was seamless and the service excellent.',
        rating: 5,
    },
];
























































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "pune-cab-service" },
        { place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "pune-taxi-hire" },
        { place: "/images/keyword/3.jpg", text: "Pune Online Cab Booking", link: "pune-online-cab-booking" },
        { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "best-cab-service-in-pune" },
        { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cabs", link: "pune-to-mumbai-cabs" },
        { place: "/images/keyword/6.jpg", text: "Pune to Nashik Cabs", link: "pune-to-nashik-cabs" },
        { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "pune-to-mahabaleshwar-cabs" },
        { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cabs", link: "pune-to-lonavala-cabs" },
        { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cab", link: "pune-to-shirdi-cab" },
        { place: "/images/keyword/10.jpg", text: "Pune to Bhimashankar Cab", link: "pune-to-bhimashankar-cab" },
        { place: "/images/keyword/11.jpg", text: "Pune to Konkan Darshan Cabs", link: "pune-to-konkan-darshan-cabs" },
        { place: "/images/keyword/12.jpg", text: "Pune Outstation Cabs", link: "pune-outstation-cabs" },
        { place: "/images/keyword/13.jpg", text: "Ashtavinayak Darshan Cab", link: "ashtavinayak-darshan-cab" },
        { place: "/images/keyword/14.jpg", text: "Pune to Goa Cabs", link: "pune-to-goa-cabs" },
        { place: "/images/keyword/15.jpg", text: "Cabs Services Near Me", link: "cabs-services-near-me" },
        { place: "/images/keyword/16.jpg", text: "Corporate Cab Service in Pune", link: "corporate-cab-service-in-pune" },
        { place: "/images/keyword/17.jpg", text: "Pune to Mumbai Airport Cabs", link: "pune-to-mumbai-airport-cabs" },
        { place: "/images/keyword/18.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Pune", link: "urbania-on-rent-in-pune" },
        { place: "/images/keyword/20.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },
        { place: "/images/keyword/21.jpg", text: "Bus On Rent in Pimpri Chinchwad", link: "bus-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
        { place: "/images/keyword/23.jpg", text: "Ertiga On Rent in Pune", link: "ertiga-on-rent-in-pune" },
        { place: "/images/keyword/24.jpg", text: "Pune to Sambhaji Nagar Taxi", link: "pune-to-sambhaji-nagar-taxi" },
        { place: "/images/keyword/25.jpg", text: "Pune to Ganpatipule Taxi", link: "pune-to-ganpatipule-taxi" }
    ];






const sedanTaxiSchema = {
  "@context": "https://schema.org",
  "@type": "TaxiService",
  "name": "Platinum24 Cabs",
  "url": "https://www.platinum24cab.com",
  "description": "Affordable and reliable sedan taxi hire service in Pune offering sedan cab rentals, airport transfers, corporate travel, outstation trips, and 24x7 service.",
  "areaServed": {
    "@type": "City",
    "name": "Pune"
  },
  "serviceType": [
    "Sedan Taxi Service Pune",
    "Pune Sedan Cab Booking",
    "Affordable Sedan Taxi Pune",
    "Sedan Car Hire Pune",
    "Pune Sedan Taxi with Driver",
    "Sedan Cab Rental Pune",
    "Pune Sedan Taxi Packages",
    "Pune Sedan Airport Taxi",
    "Pune Sedan Outstation Taxi",
    "Sedan Taxi Deals Pune",
    "Pune Sedan Taxi Rates",
    "Sedan Taxi for Corporate Pune",
    "Sedan Taxi Service Near Me Pune",
    "Sedan Taxi Booking Online Pune",
    "Pune Sedan Cab Service 24x7"
  ],
  "telephone": "+91-XXXXXXXXXX"
};








    return (
        <div>
<Helmet>
  <title>Sedan Taxi Hire in Pune | Affordable Sedan Cab Service</title>
  <meta
    name="description"
    content="Affordable and reliable sedan taxi hire service in Pune offering sedan cab rentals, airport transfers, corporate travel, outstation trips, and 24x7 service."
  />
  <meta
    name="keywords"
    content="Sedan Taxi Service Pune, Pune Sedan Cab Booking, Affordable Sedan Taxi Pune, Sedan Car Hire Pune, Pune Sedan Taxi with Driver, Sedan Cab Rental Pune, Pune Sedan Taxi Packages, Pune Sedan Airport Taxi, Pune Sedan Outstation Taxi, Sedan Taxi Deals Pune, Pune Sedan Taxi Rates, Sedan Taxi for Corporate Pune, Sedan Taxi Service Near Me Pune, Sedan Taxi Booking Online Pune, Pune Sedan Cab Service 24x7"
  />
  <script type="application/ld+json">
    {JSON.stringify(sedanTaxiSchema)}
  </script>
</Helmet>


            <div
                className="breadcumb-wrapper"
                // style={{ backgroundImage: "url('/img/breadcumb/breadcumb-bg.jpg')" }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                        <div className="breadcumb-menu-wrap">
                        </div>
                    </div>
                </div>
            </div>










            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/62.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>
                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        <div className="service-icon">
                                            🚖
                                        </div>
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Platinum24 Cabs</span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Platinum24 Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+917507048333" className="pc-call">+91 7507048333</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/917507048333"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+917507048333" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@platinum24cab.com" className="pc-email">
                                            booking@platinum24cab.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Platinum24 Cabs</strong><br />
                                            OFFICE NO.2, SECTOR NO.4, PLOT NO.295(S), SAI GANGA APARTMENT, ABOVE UMED ELECTRICAL, NEAR ACORD HOSPITAL
                                            FIRST FLOOR, SANT NAGAR, MOSHI, PUNE 412105
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Sedantaxihireinpune;